import { AppState } from "..";

export const distanceSelector = (state: AppState) => state.general.distance;
